var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1081 46.082H10",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.054 49.8652C24.3525 49.8652 24.5945 50.1072 24.5945 50.4058V50.4058C24.5945 50.7043 24.3525 50.9463 24.054 50.9463V50.9463C23.7555 50.9463 23.5135 50.7043 23.5135 50.4058V50.4058C23.5135 50.1072 23.7555 49.8652 24.054 49.8652",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1081 36.3514V50.4054C38.1081 52.7937 36.172 54.7297 33.7838 54.7297H14.3243C11.9361 54.7297 10 52.7937 10 50.4054V9.32432C10 6.93607 11.9361 5 14.3243 5H27.2973",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0002 24.4595C48.0636 22.542 46.9079 19.974 46.7569 17.253V13.6486C46.7569 8.87213 42.8848 5 38.1083 5C33.3317 5 29.4596 8.87213 29.4596 13.6486V17.253C29.3086 19.974 28.1529 22.542 26.2164 24.4595H50.0002Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3277 28.7832C35.6513 30.0547 36.7962 30.9447 38.1082 30.9447C39.4203 30.9447 40.5652 30.0547 40.8888 28.7832",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSms);
export default __webpack_public_path__ + "static/media/icon-sms.ca14e25a.svg";
export { ForwardRef as ReactComponent };